module.exports = __webpack_public_path__ + "static/step_3_4-45fa90cb2af83b87b36a6b5efce9f974.svg";